import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './style.module.scss';
import { Popover } from '@components-clean/core/popover/popover';
import { useBoolean } from '@hooks/index';

interface InformationProps {
    title?: string | React.ReactElement;
}

const Information = ({ title }: InformationProps) => {
    const anchorRef = React.useRef<HTMLDivElement | null>(null);
    const show = useBoolean(false);

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div onMouseEnter={() => show.setTrue()} onMouseLeave={() => show.setFalse()} ref={anchorRef}>
                <FontAwesomeIcon
                    style={{ transform: 'rotate(180deg)' }}
                    fontSize={16}
                    icon={['far', 'circle-exclamation']}
                    className={Styles.iconOpacity}
                />
            </div>
            <Popover
                show={show.value}
                anchor={anchorRef.current}
                position="bottom"
                data-testid="popover-information-datatestid"
                animate={false}
                isInfo
                collision={{
                    vertical: 'flip',
                    horizontal: 'fit',
                }}
            >
                {title}
            </Popover>
        </>
    );
};

export default Information;
